import Swal from "sweetalert2";
//获取视频时长
export function getVideoDuration(file, fun) {
  let url = typeof file == "string" ? file : window.URL.createObjectURL(file);
  //   console.log("url", url);
  var video = document.createElement("video");
  video.preload = "metadata";
  video.onloadedmetadata = () => {
    let duration = video.duration;
    console.log("视频时长", duration);
    fun(duration);
    window.URL.revokeObjectURL(url);
  };
  video.src = url;
}

//获取审核记录列表的审核状态
export function getAuditAction(item) {
  let type = item.processType;
  if (type == "PENDING") {
    return "待审核";
  }
  if (type == "PASS") {
    return "通过";
  }
  if (type == "REJECT") {
    return "驳回";
  }
  if (type == "WITHDRAW") {
    return "撤销审核";
  }
  return "--";
}

//获取类型中文名
export function getTypeName(type) {
  let arr1 = [
    "article",
    "video",
    "subject",
    "stream",
    "discuss",
    "H5",
    "collection",
    "image_collection",
    "audio_collection",
    "video_collection",
    "channel",
    "circle",
    "topic",
    "qa",
    "media",
    "index",
    "activity",
    "carousel",
    "version",
    "comment",
    "splash",
    "bullet_screen",
    "qa_bank",
    "broadcast",
    "program",
    "tv",
    "tv_program",
    "highlight",
    "process",
  ];
  let arr2 = [
    "文章",
    "视频",
    "专题",
    "直播",
    "热议",
    "H5",
    "合集",
    "图片合集",
    "音频合集",
    "视频合集",
    "频道",
    "圈子",
    "话题",
    "问答",
    "媒体号",
    "首页",
    "活动",
    "轮播图",
    "版本",
    "评论",
    "闪屏",
    "弹幕",
    "题库",
    "广播",
    "广播节目",
    "电视",
    "电视节目",
    "圈看点",
    "流程",
  ];
  let num = arr1.indexOf(type);
  if (num === -1) {
    return "--";
  } else {
    return arr2[num];
  }
}

// import { log } from "@/util/fun.js";
export const log = window.canDebug ? console.log : () => {};
export const waitTime = function(time_duration) {
  return new Promise((resolve) => {
    let a = setTimeout(() => {
      resolve("end");
      clearTimeout(a);
    }, time_duration);
  });
};

//判断图片链接是否有效
export const checkImageLink = function(url) {
  return new Promise(function(resolve) {
    var ImgObj = new Image(); //判断图片是否存在
    ImgObj.onload = function(res) {
      resolve(true);
    };
    ImgObj.onerror = function(err) {
      resolve(false);
    };
    ImgObj.src = url;
  }).catch((e) => {
    console.log("图片加载出错", e);
  });
};
// 列表排序算法,param为原来的排序参数名，比如"viewOrder"，param2为排序时接口需要的参数名，比如"order"
// 返回更新了排序值的新列表和调用接口需要的参数,idName为排序时接口需要的id参数，默认为"id"(有些地方排序的id不是取的列表里面的id字段)
export const getSortParams = function(
  list_old,
  list_new,
  param,
  param2,
  idName
) {
  let old_arr = JSON.parse(JSON.stringify(list_old)); //list_new里面的对象和list_old里面的是一样的，所以有必要复制一下。
  let new_arr = [];
  let params = [];
  let id_name = idName || "id";
  list_new.forEach((item, index) => {
    let obj = item;
    obj[param] = old_arr[index][param];
    new_arr.push(obj);
    let obj1 = {
      id: item[id_name],
    };
    obj1[param2] = obj[param];
    params.push(obj1);
  });
  return {
    list: new_arr,
    params,
  };
};

//运营数字验证
export const getOperateNum = function(str, type) {
  //什么都没填时传null
  if (str === "" || str === undefined || str === null) {
    return null;
  }
  let num = Number(str);
  //非数字、小于0、非整数时报错提醒
  if (isNaN(num) || num < 0 || parseInt(num) !== num) {
    let msg = "";
    if (type == "view") {
      msg = "运营阅读数";
    } else if (type == "like") {
      msg = "运营点赞数";
    } else if (type == "online") {
      msg = "运营在线人数";
    } else if (type == "follow") {
      msg = "运营关注数";
    } else {
      msg = type;
    }
    msg += "填写有误";
    return msg;
  } else {
    return num;
  }
};
//获取预览链接，弹窗预览都带参数
export const getPreLink = function(item) {
  if (typeof item != "object") {
    return "";
  }
  return item.previewUrl + "&backend=true";
};

//获取复制链接和展示链接二维码，上线列表都不带参数
export const getCopyLink = function(item) {
  if (typeof item != "object") {
    return "";
  }
  if (item.verifyState != 1) {
    return item.previewUrl + "&backend=true";
  } else {
    return item.previewUrl;
  }
};

//复制链接
export const copyLink = function(str, msg) {
  if (str === undefined || str === null || str === "") {
    Swal.fire({
      title: "没有" + msg,
      icon: "success",
      showCloseButton: false,
      showConfirmButton: false,
      timer: 1000,
    });
    return;
  }
  let input = document.createElement("input");
  input.setAttribute("readonly", "readonly");
  input.setAttribute("value", str);
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
  if (typeof msg == "string") {
    Swal.fire({
      title: `复制${msg}成功`,
      icon: "success",
      showCloseButton: false,
      showConfirmButton: false,
      timer: 1000,
    });
  }
};

//内容管理保存前检查标题是否重复
import manager from "@/server/api/contentManager";
export async function checkRepeatTitle(item) {
  console.log("检查标题", item.title, item.id);
  return new Promise((resolve) => {
    manager
      .list({
        page: 1,
        pageSize: 1,
        title: item.title,
        volcano: 0, //不展示与火山内容重复
      })
      .then((res) => {
        if (typeof res == "object" && res.code === 0 && res.data) {
          let num = item.id ? 1 : 0;
          if (
            res.data.total > num ||
            (item.id && res.data.total == 1 && res.data.items[0].id != item.id)
          ) {
            Swal.fire({
              html:
                "<div style='color:red'>有重复内容标题，是否继续保存？</div>",
              icon: "question",
              showCancelButton: true,
              confirmButtonColor: "#f46a6a",
              cancelButtonColor: "#74788d",
              confirmButtonText: "继续",
              cancelButtonText: "取消",
            }).then((result) => {
              if (result.value) {
                resolve(true);
              } else {
                resolve(false);
              }
            });
          } else {
            resolve(true);
          }
        } else {
          resolve(false);
        }
      });
  });
}

export const getTimeNow = function() {
  var t = new Date();
  var year = t.getFullYear();
  let tem = t.getMonth();
  var month = tem >= 9 ? tem + 1 : "0" + (tem + 1);
  tem = t.getDate();
  var day = tem >= 10 ? tem : "0" + tem;
  tem = t.getHours();
  var hour = tem >= 10 ? tem : "0" + tem;
  tem = t.getMinutes();
  var minute = tem >= 10 ? tem : "0" + tem;
  tem = t.getSeconds();
  var second = tem >= 10 ? tem : "0" + tem;
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
};

export const getDateNow = function() {
  var t = new Date();
  var year = t.getFullYear();
  let tem = t.getMonth();
  var month = tem >= 9 ? tem + 1 : "0" + (tem + 1);
  tem = t.getDate();
  var day = tem >= 10 ? tem : "0" + tem;
  return `${year}-${month}-${day}`;
};

export const passwordValidate = function(str, min, max) {
  let length = str.length;
  if (length < min || (max && length > max)) {
    return false;
  }
  if (/[^a-zA-Z0-9=!"#$%&'()*+,-.\/\\:;<>?@^_`{}|~[\]]/.test(str)) {
    return false;
  }
  if (
    !/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[=!"#$%&'()*+,-.\/\\:;<>?@^_`{}|~[\]])/.test(
      str
    )
  ) {
    return false;
  }
  return true;
};

//处理富文本内容，禁止下载富文本的图片、视频、音频
export const forbidMediaDownload = function(content) {
  let str = content;
  let videoReg = /<video[^<>]{0,}>/g;
  let audioReg = /<audio[^<>]{0,}>/g;
  let imgReg1 = /<img[^<>]{0,}>/g;
  let imgReg2 = /<img[^<>]{0,}\/>/g;
  let arr = content.match(videoReg);
  if (arr) {
    arr.forEach((item) => {
      let tem = item;
      if (item.indexOf("controlslist") == -1) {
        tem = tem.substring(0, tem.length - 1) + ' controlslist="nodownload">';
      }
      if (item.indexOf("oncontextmenu") == -1) {
        tem =
          tem.substring(0, tem.length - 1) + ' oncontextmenu="return false">';
      }
      if (tem != item) {
        str = str.replace(item, tem);
      }
    });
  }
  arr = content.match(audioReg);
  if (arr) {
    arr.forEach((item) => {
      let tem = item;
      if (item.indexOf("controlslist") == -1) {
        tem = tem.substring(0, tem.length - 1) + ' controlslist="nodownload">';
      }
      if (item.indexOf("oncontextmenu") == -1) {
        tem =
          tem.substring(0, tem.length - 1) + ' oncontextmenu="return false">';
      }
      if (tem != item) {
        str = str.replace(item, tem);
      }
    });
  }
  arr = content.match(imgReg1);
  if (arr) {
    arr.forEach((item) => {
      let tem = item;
      if (item.indexOf("oncontextmenu") == -1) {
        tem =
          tem.substring(0, tem.length - 1) + ' oncontextmenu="return false">';
      }
      if (tem != item) {
        str = str.replace(item, tem);
      }
    });
  }
  arr = content.match(imgReg2);
  if (arr) {
    arr.forEach((item) => {
      let tem = item;
      if (item.indexOf("oncontextmenu") == -1) {
        tem =
          tem.substring(0, tem.length - 2) + ' oncontextmenu="return false">';
      }
      if (tem != item) {
        str = str.replace(item, tem);
      }
    });
  }
  return str;
};

//给富文本的视频加上iOS WKWebView播放视频时禁用自动全屏播放属性
export const addAttrToTagVideo = function(content) {
  let str = content;
  let reg = /<video[^<>]{0,}>/g;
  let arr = str.match(reg);

  if (arr) {
    arr = arr.filter((item) => item.indexOf("playsinline") === -1);
  } else {
    arr = [];
  }

  if (arr.length) {
    arr.forEach((item) => {
      str = str.replace(
        item,
        item.substring(0, item.length - 1) +
          ' webkit-playsinline="true" playsinline="true">'
      );
    });
  }
  return str;
};

//获取文件名和后缀名
export const getFileName = function(url, judge) {
  let obj = {
    name: "",
    suffix: "",
  };
  if (typeof url == "string") {
    let str = url.split("/").splice(-1, 1)[0];
    let index1;
    if (judge) {
      index1 = str.indexOf(".");
    } else {
      index1 = str.lastIndexOf(".");
    }
    if (index1 == -1) {
      obj.suffix = "";
      index1 = str.indexOf("?");
      if (index1 == -1) {
        obj.name = str;
      } else {
        obj.name = str.substring(0, index1);
      }
    } else {
      let str2 = str.substring(index1 + 1);
      let reg = /[^0-9a-zA-Z]{1,1}/;
      let index2 = str2.search(reg);
      if (index2 == -1) {
        obj.name = str;
        obj.suffix = str2.toLowerCase();
      } else {
        obj.name = str.substring(0, index1 + 1 + index2);
        obj.suffix = str2.substring(0, index2).toLowerCase();
      }
    }
  }
  return obj;
};

//检查一个数组中是否有指定对象，用一个参数判断,false为没有
export const checkExist = function(arr, params, value) {
  let length = arr.length;
  if (length == 0) {
    return false;
  }
  for (let i = 0; i < length; i++) {
    if (arr[i][params] === value) {
      return i;
    }
  }
  return false;
};

//删除数组arr中某个元素并返回新数组，用param判断
//item可以为对象或者数字或者数字数组
export function deleteArrItem(arr, item, param) {
  let new_arr = JSON.parse(JSON.stringify(arr));
  let index;
  if (Array.isArray(item)) {
    item.forEach((tr) => {
      index = checkExist(new_arr, param, tr);
      if (index !== false) {
        new_arr.splice(index, 1);
      }
    });
  } else {
    index = checkExist(
      new_arr,
      param,
      typeof item == "number" ? item : item[param]
    );
    if (index !== false) {
      new_arr.splice(index, 1);
    }
  }
  return new_arr;
}

//改变列表数据
export function changeList(type, arr, items, param, param2) {
  //删除
  if (type == "delete") {
    return deleteArrItem(arr, items, param);
  }
  //改变属性
  if (type == "changeAttribute") {
    let id = param2 || "id";
    let new_arr = JSON.parse(JSON.stringify(arr));
    new_arr.forEach((item, index) => {
      if (items.indexOf(item[id]) != -1) {
        new_arr[index] = { ...item, ...param };
      }
    });
    return new_arr;
  }
}

export const filterTagsAttrs = (dom) => {
  //移除富文本标签的多余属性
  const commonAttrs = ["style", "class"]; //所有标签需要保留的属性
  const tagFilters = [
    // {
    //   tags: [
    //     "div",
    //     "span",
    //     "p",
    //     "section",
    //     "strong",
    //     "h1",
    //     "h2",
    //     "h3",
    //     "h4",
    //     "h5",
    //     "h6",
    //     "u",
    //     "em",
    //   ], //标签列表
    //   saveAttrs: [], //额外需要保留的属性
    // },
    {
      tags: ["img"],
      saveAttrs: [
        "oncontextmenu", //右击菜单
        "object-fit", //大小自适应方式,
        "alt", //不能展示显示的文字
        "src",
        "height",
        "width",
      ],
    },
    // {
    //   tags: ["a"],
    //   saveAttrs: [
    //     "title", //鼠标悬浮展示的文字
    //     "target",
    //     "href",
    //     "rel",
    //     "type",
    //     "download",
    //     "hreflang",
    //   ],
    // },
  ];
  tagFilters.forEach((obj) => {
    obj.tags.forEach((item) => {
      let arr = dom.getElementsByTagName(item);
      console.log("当前tag是" + item, "项为", arr);
      let length = arr.length;
      if (length) {
        for (let i = 0; i < length; i++) {
          let el = arr[i];
          if (item == "img") {
            if (!el.src) {
              //复制过来的图片如果没有src属性但有_src属性则用_src属性的值替换src的值
              let url = el.getAttribute(_src);
              if (url) {
                el.src = url;
              }
            }
          }
          let attrs = el.attributes;
          console.log("属性大全", el, attrs);
          let length2 = attrs.length;
          if (length2) {
            let remove = [];
            for (let a = 0; a < length2; a++) {
              if (!attrs[a]) {
                continue;
              }
              let attr = attrs[a].name;
              console.log("当前属性", attr);
              if (attr.indexOf("-mce-") != -1 || attr == "contenteditable") {
                //去掉这两个属性会导致富文本里面的音频和视频无法选中和播放
                continue;
              }
              if (
                commonAttrs.indexOf(attr) == -1 &&
                obj.saveAttrs.indexOf(attr) == -1
              ) {
                remove.push(attr);
              }
            }
            if (remove.length) {
              console.log("需要移除的属性", remove);
              remove.map((a) => {
                el.removeAttribute(a);
              });
            }
          }
        }
      }
    });
  });
};
//如果新获取的列表里的图片和之前一样就把地址替换为之前的
//就不用重新加载节省服务器流量(因为签名不同会重新下载)
export const replaceImgUrl = (newList, oldList, otherList) => {
  if (!newList || newList.length == 0) {
    return [];
  }
  let attr = ["image", "cover", "url", "coverUrl"];
  let arr = newList;
  let old_arr = oldList;
  if (!old_arr || old_arr.length == 0) {
    old_arr = [];
  }
  if (otherList && otherList.length) {
    old_arr = old_arr.concat(otherList);
  }
  if (old_arr.length) {
    arr.forEach((item) => {
      let obj;
      if (item) {
        old_arr.some((tr) => {
          if (tr && tr.id == item.id) {
            obj = tr;
            return true;
          }
        });
        if (obj) {
          attr.forEach((tr) => {
            if (item[tr] && obj[tr]) {
              if (
                decodeURI(item[tr]).split("?")[0] ==
                decodeURI(obj[tr]).split("?")[0]
              ) {
                item[tr] = obj[tr];
              }
            }
          });
        }
      }
    });
  }
  return arr;
};